export default __webpack_public_path__ + "static/media/globe-blue.2b471761.svg";